import { render, staticRenderFns } from "./AmountYN.vue?vue&type=template&id=15057cd8"
import script from "./AmountYN.vue?vue&type=script&lang=js"
export * from "./AmountYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports